// ReminderSection.tsx
import React from "react";
import SectionCard from "./SectionCard";
import Field from "./Field";
import Toggle from "./Toggle";
import { ReminderData } from "./types";

const input = "w-full border border-gray-200 rounded-lg px-3 py-2 text-sm";

interface Props {
  data: ReminderData;
  onChange: (data: ReminderData) => void;
}

export default function ReminderSection({ data, onChange }: Props) {
  const set = (key: keyof ReminderData, value: any) => onChange({ ...data, [key]: value });

  return (
    <SectionCard step={4} title="Reminder & Follow-up">
      <div className="grid sm:grid-cols-3 gap-4">
        <div>
          <div className="flex items-center gap-3">
            <Toggle on={data.enabled} onToggle={(v) => set("enabled", v)} />
            <span className="text-sm font-medium">Enable Payment Reminders</span>
          </div>
          <p className="text-xs text-gray-400 mt-1">Send automatic payment reminders</p>
        </div>

        <Field label="Reminder Days" hint="Comma separated, e.g. 1, 3, 7, 15">
          <input className={input} value={data.days} onChange={(e) => set("days", e.target.value)} />
        </Field>

        <Field label="Reminder Time">
          <select className={input} value={data.time} onChange={(e) => set("time", e.target.value)}>
            <option>9:00 AM</option>
            <option>10:00 AM</option>
            <option>11:00 AM</option>
            <option>12:00 PM</option>
          </select>
        </Field>
      </div>
    </SectionCard>
  );
}
